import { render, staticRenderFns } from "./addChannle.vue?vue&type=template&id=80b69750&"
import script from "./addChannle.vue?vue&type=script&lang=js&"
export * from "./addChannle.vue?vue&type=script&lang=js&"
import style0 from "./addChannle.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('80b69750')) {
      api.createRecord('80b69750', component.options)
    } else {
      api.reload('80b69750', component.options)
    }
    module.hot.accept("./addChannle.vue?vue&type=template&id=80b69750&", function () {
      api.rerender('80b69750', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/gateway/components/addChannle.vue"
export default component.exports